import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '@app/shared/services/auth.service';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { AppInsightsServiceDirective } from '@app/shared/services/app-insights.service';
import { ApplicationInsightEvent } from '@app/shared/enums';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { UserStoreService } from '@app/shared/services/store/user-store.service';
import { ContinueEditingService } from '@app/shared/services/continue-editing.service';
import { CloseDialogResult } from '@app/shared/models/dialog/continue-editing-dialog.model';

@Component({
  selector: 'app-user-profile-menu',
  templateUrl: './user-profile-menu.component.html',
  styleUrls: ['./user-profile-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserProfileMenuComponent implements OnInit {
  get environment() {
    return environment;
  }

  constructor(
    public authService: AuthService,
    public appInsightsServiceDirective: AppInsightsServiceDirective,
    public overlayLoaderService: OverlayLoaderService,
    public router: Router,
    public userStore: UserStoreService,
    private continueEditingService: ContinueEditingService
  ) {}

  versionLink: any;
  invitePermission = false;

  public ngOnInit() {
    this.versionLink = `${environment.proxyApiURL}/api/releaseversiontext`;
  }

  public goTo(routes: string[]) {
    this.router.navigate(routes, { replaceUrl: true });
  }

  public async logout() {
    const dialogRef = await this.continueEditingService.openContinueEditingDialog();
    if (dialogRef !== CloseDialogResult.continueEditing) {
      this.overlayLoaderService.isLoading = true;

      this.appInsightsServiceDirective.logEvent(ApplicationInsightEvent.logout);

      setTimeout(() => {
        this.authService.logout();
      }, 2000);
    }
  }

  public downloadReleaseNotes() {
    const link = document.createElement('a');
    link.setAttribute('href', this.versionLink);
    link.setAttribute('target', '_blank');
    link.setAttribute('download', 'ReleaseNotest.txt');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
